<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="sysMsg.dialog"
      width="600"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{sysMsg.title}}
        </v-card-title>

        <v-card-text v-html="sysMsg.content" class="system-content">
          {{sysMsg.content}}
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="Noted" ><v-icon>info</v-icon>Noted</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { readSysMsg } from '@/api/layout'
import {
  mapGetters
} from 'vuex'
export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'sysMsg'
    ])
  },
  mounted () {

  },
  methods: {
    Noted () {
      readSysMsg(this.sysMsg.mid).then(res => {
        this.$store.dispatch('closeSysMsg')
        if (res.data.ErrorCode !== 0 && !this.sysMsg.remind) {
          this.$root.$alertTips(res.data.Msg)
        }
      })
    }
  }
}
</script>
<style>
.system-content img{
  max-width: 100%;
}
</style>
